<template>
<div class="digPop">
	<div class="digPopInner">
		<div class="digPopCont">
			<slot></slot>
		</div>
		<a href="javascript:;" class="btnclose" @click="fnEventBus">팝업닫기</a>
	</div>
</div>
</template>
<script>
export default {
 methods: {
	 fnEventBus(event){
		 this.$emit('event_bus' , event)
	 }
 },
}
</script>
<style scope>

</style>